import { Component, Inject } from '@angular/core';
import { SubSink } from 'subsink2';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MyEInvoiceRequestRejectionContainerModel, MyEInvoiceRequestRejectionService, MyEInvoiceToIrbContainerContainerModel, Pagination } from 'blg-akaun-ts-lib';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from '../../visa';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-rejection-reason-popup',
  templateUrl: './rejection-popup.component.html',
  styleUrls: ['./rejection-popup.component.scss'],
})
export class RejectionReasonPopUpComponent{

  protected subs = new SubSink();
  protected prevLocalState: any;

  defaultRejectionReasons: string[] = [
    'Wrong buyer details',
    'Wrong invoice details',
    'Others'
  ];

  prevIndex: number;

  modeValue;
  disableCreate = false;
  private readonly apiVisa = AppConfig.apiVisa;


  constructor(
    private dialogRef: MatDialogRef<RejectionReasonPopUpComponent>,
    private requestRejectionService: MyEInvoiceRequestRejectionService,
    private toaster: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: MyEInvoiceToIrbContainerContainerModel
    ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onCloseDialog(){
    this.dialogRef.close();
  }

  selectedReason: string;


  onCancel() {
    this.dialogRef.close();
  }

  onSelect(reason: string) {
    this.selectedReason = reason;
  }

  onSubmit() {
    const pagination = new Pagination();
    pagination.conditionalCriteria = [
      { columnName: 'to_irb_doc_hdr_guids', operator: '=', value: this.data?.bl_fi_my_einvoice_to_irb_hdr.guid?.toString() },
    ];

    const requestRejectionContainerModel = new MyEInvoiceRequestRejectionContainerModel();
    const header = requestRejectionContainerModel.bl_fi_my_einvoice_request_rejection_internal_doc_hdr;
    header.generic_doc_hdr_guid = this.data?.bl_fi_my_einvoice_to_irb_hdr.generic_doc_hdr_guid;
    header.server_doc_type = this.data?.bl_fi_my_einvoice_to_irb_hdr.generic_doc_hdr_server_doc_type;
    header.doc_ccy = this.data?.bl_fi_my_einvoice_to_irb_hdr.doc_ccy;
    header.original_einvoice_txn_date = this.data?.bl_fi_my_einvoice_to_irb_hdr.einvoice_datetime;
    header.amount_txn = this.data?.bl_fi_my_einvoice_to_irb_hdr.amount_txn;
    header.txn_date = new Date(this.data?.bl_fi_my_einvoice_to_irb_hdr.date_txn);
    header.einvoice_buyer_entity_hdr_guid = this.data?.bl_fi_my_einvoice_to_irb_hdr.einvoice_buyer_entity_hdr_guid;
    header.einvoice_supplier_entity_hdr_guid = this.data?.bl_fi_my_einvoice_to_irb_hdr.einvoice_supplier_entity_hdr_guid;
    header.server_doc_1 = this.data?.bl_fi_my_einvoice_to_irb_hdr.generic_doc_hdr_server_doc_1;
    header.to_irb_doc_hdr_guid = this.data?.bl_fi_my_einvoice_to_irb_hdr.guid;
    header.request_submitted_datetime = new Date();
    header.reason = this.selectedReason;
    
    this.subs.sink = this.handleRejectionRequest(pagination, requestRejectionContainerModel).subscribe((result) => {
        this.dialogRef.close(result); 
    });
  }

  private handleRejectionRequest(pagination: Pagination, container: MyEInvoiceRequestRejectionContainerModel): Subject<MyEInvoiceRequestRejectionContainerModel> {
    const result = new Subject<MyEInvoiceRequestRejectionContainerModel>();
  
    this.subs.sink = this.requestRejectionService.getByCriteria(pagination, this.apiVisa).pipe(
      switchMap(response => {
        if (response.data && response.data.length > 0) {
          this.toaster.warning("Request already exists", "Warning", {
            tapToDismiss: true,
            progressBar: true,
            timeOut: 1300,
          });
          result.next(null);
          result.complete();
          return [];
        } else {
          return this.requestRejectionService.post(container, this.apiVisa).pipe(
            map(resp => {
              this.toaster.success("Request for Rejection", "Success", {
                tapToDismiss: true,
                progressBar: true,
                timeOut: 1300,
              });
              const requestHdr = resp.data as any;
              result.next(requestHdr);
              result.complete();
            }),
            catchError((err) => {
              this.toaster.error(err.message, "Error", {
                tapToDismiss: true,
                progressBar: true,
                timeOut: 1300,
              });
              result.next(null);
              result.complete();
              throw err;
            })
          );
        }
      }),
      catchError((err) => {
        this.toaster.error(err.message, "Error", {
          tapToDismiss: true,
          progressBar: true,
          timeOut: 1300,
        });
        result.next(null);
        result.complete();
        throw err;
      })
    ).subscribe();
  
    return result;
  }
}